import React, { Component } from 'react';
import { Selected_Index, WIRELINE_REQUEST_TYPES_ID } from '../../../../../constants/external-constants';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';
import ButtonIcon from '../../../../button';
import OrderDetailsForm from '../order-form/order-details-form.component';
import { withRouter } from 'react-router-dom';
import { requestDetailsActions } from "../../../../../store/external/request-reducer/request-details.reducer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { requestLogActions } from "../../../../../store/external/request-reducer/request-log.reducer";
import { ROUTE_LINK_LOCATION, REQUEST_TYPES_ID } from "../../../../../constants/external-constants";
import OrderCommentsComponent from '../order-comments/order-comments.component';
import OrderHistoryComponent from '../order-history/order-history.component';
import OrderCircuit from '../order-circuit/order-circuit.component';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import WirelineOrderCircuit from '../wireline-order-circuit/wireline-order-circuit.component';
import { validateAccessModule } from '../../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../utils/rbac-constants.utils';
class OrderDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            showModal: {
                show: false,
                title: "",
                message: "",
                buttonName: ""
            },
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Circuit Details",
                    "hidden": false,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "Line Items",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Three,
                    "label": "Audit",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Four,
                    "label": "Cost Allocation",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Five,
                    "label": "Comments",
                    "hidden": false,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Six,
                    "label": "History",
                    "hidden": false,
                    "disable": false
                }
              
            ],
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    FilterIndex = (index) =>{
        const { circuitOrder, item } = this.props
        if(
            index == Selected_Index.i_One 
            && !circuitOrder.CircuitId 
            && (item.RequestTypeId == REQUEST_TYPES_ID.other || item.RequestTypeId == REQUEST_TYPES_ID.wirelineOtherOther) ){
            this.toggleShowNotice(true, this.toLocaleLanguage("notice_title", false), this.toLocaleLanguage("modal_order_notice_message", false), this.toLocaleLanguage("modal_error_button", false));
        }
        else{
            this.setState({selectedIndex: index});
        }
    }

    activeListTab = (listTab) => {
        const { disputeDetailsId, item } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && disputeDetailsId > 0) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }
    openRequestDetails = (id, type, orderStatusId) =>{
        const { history, location, orderDetailsId, item, setSelectedRequest, setUpdatedRequestStatus, quotationRequestId } = this.props;
        var fetchRequestTypeId = item.RequestTypeId === REQUEST_TYPES_ID.newQuotation
        var isRequestTypeId = fetchRequestTypeId ? quotationRequestId : orderDetailsId
        if (fetchRequestTypeId) {
            setSelectedRequest(item, true);           
        }
        else {
            setSelectedRequest(item);        
         }
        setUpdatedRequestStatus(orderStatusId);
        history.push(`${ROUTE_LINK_LOCATION.orderDetailsRouteLink}${isRequestTypeId}`);
    }

    toggleShowNotice = (isShow, title, message, buttonName) => {
        const { showModal } = this.state;
        this.setState({
            showModal: {
                ...showModal,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
                buttonName: buttonName
            }
        });
    }

    hideTabIndex = () => {
        const {item} = this.props;
        const hideIndices = [];
        if (parseInt(item.RequestTypeId) === parseInt(WIRELINE_REQUEST_TYPES_ID.newQuotation))
        {
            return hideIndices.push(1)
        }
        
        return hideIndices
    }

    render() {       
        const { listTab, selectedIndex, closeDetailsView } = this.state;
        const { closeForm, children, orderDetailsId, item, circuitOrder, quotationRequestId, stripeInfo } = this.props
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.OrderOrderDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.OrderOrderDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.OrderOrderDashboardRW])

        const roles = {
            isReadOnly,
            isReadAndWrite,
            isReadAndExtractOnly
        }
        return (
             <div className="layout-container">
            
                <ButtonIcon onClick={closeForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} hideIndex={[this.hideTabIndex()]} /> : null}
                {selectedIndex === Selected_Index.i_Zero && 
                <OrderDetailsForm stripeInfo={stripeInfo} 
                    orderDetailsId={orderDetailsId} 
                    quotationRequestId={quotationRequestId} 
                    requestTypeId={item.RequestTypeId} 
                    orderNumber={item.OrderNumber}
                    OpenRequestDetails={this.openRequestDetails} 
                    roles={roles} isReadAndWrite={isReadAndWrite} 
                />}
                {selectedIndex === Selected_Index.i_One && (
                    parseInt(item.RequestTypeId) === parseInt(WIRELINE_REQUEST_TYPES_ID.newSubscriptionWireline)  ?
                        <WirelineOrderCircuit orderDetailsId={orderDetailsId} requestTypeId={item.RequestTypeId} ranking={item.PrimarySecondary} roles={roles} isReadAndWrite={isReadAndWrite} />
                        :
                        <OrderCircuit orderDetailsId={orderDetailsId} requestTypeId={item.RequestTypeId} ranking={item.PrimarySecondary} roles={roles} isReadAndWrite={isReadAndWrite} />
                )
                }
                {selectedIndex === Selected_Index.i_Five && <OrderCommentsComponent orderDetailsId={orderDetailsId} quotationRequestId={quotationRequestId} roles={roles} />}
                {selectedIndex === Selected_Index.i_Six && <OrderHistoryComponent orderDetailsId={orderDetailsId} hideCustomColumn={true} quotationRequestId={quotationRequestId} requestTypeId={item.RequestTypeId} roles={roles} />}
                {children}
            
                <NotificationModal
                    show={this.state.showModal.show}
                    title={this.state.showModal.title}
                    message={this.state.showModal.message}
                    buttonName={this.state.showModal.buttonName}
                    handleModal={() => this.toggleShowNotice(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />

            </div>
        );
    }
}


export default connect(
    state => {
        const { requestLog, circuitOrder } = state;
        return {
            ...requestLog,
            circuitOrder,
            translation
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, requestDetailsActions),
            dispatch
        )
)(withRouter(OrderDetails));
